import { useEffect, useRef, useState } from 'react'
import { SDrawerOrModal } from 'shj-components'
import { Button, message, Spin, Typography } from 'antd'
import { useSetState } from 'ahooks'
import { checkForNotifyCustomer, notifyCustomer } from '@/services/order'
import styles from './index.module.less'
import { isArray } from 'lodash-es'
import Paragraph from 'antd/es/skeleton/Paragraph'

interface IProps {
  title: string
  open: boolean
  orderId: string
  setOpen: (open: boolean) => void
  detailsInfo: Record<string, any>
}

export default function ExpectedStartWorkTime(props: IProps) {
  const { open, title, setOpen, orderId } = props
  const [errorList, setErrorList] = useState<any>([])
  const [state, setState] = useSetState<any>({
    loading: false,
    btnLoading: false,
    btnDisabled: true,
  })

  const onsubmit = () => {
    setState({ btnLoading: true })
    notifyCustomer({ orderId })
      .then(res => {
        console.log('通知客户----------', res)
        message.success('通知成功')
        setOpen(false)
      })
      .finally(() => {
        setState({ btnLoading: false })
      })
  }

  const onCancel = () => {
    setOpen(false)
  }

  const getInit = () => {
    setState({ loading: true })
    checkForNotifyCustomer({ orderId })
      .then(res => {
        const list: any[] = isArray(res) ? res : []
        setState({ btnDisabled: list.length > 0 })
        setErrorList(list)
      })
      .finally(() => {
        setState({ loading: false })
      })
  }

  useEffect(() => {
    open && getInit()
  }, [open, orderId])

  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
              disabled={state.btnDisabled}
            >
              通知客户
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div className={styles.expectedStartWorkTime}>
          <Spin spinning={state.loading}>
            <div>
              <p style={{ marginBottom: 10 }}>
                点击“通知客户”按钮后，系统将通过短信形式通知客户。客户选择预计开工日期后，设计师才允许发起主合同。
              </p>
              <p style={{ marginBottom: 10 }}>
                “申请开工”时的“预计交底日期”以客户选择的日期为准，如需调整请再次通知客户，由客户自行操作。
              </p>
            </div>
            {isArray(errorList) && errorList?.length > 0 && (
              <div className={styles.errorBox}>
                <div style={{ marginBottom: 10 }}>【异常信息】</div>
                {errorList?.map((key: any, index: number) => {
                  return (
                    <Typography.Paragraph style={{ marginBottom: 5 }} ellipsis={{ rows: 2, tooltip: true }}>
                      <span className={styles.redColor}>
                        {index + 1}、{key || ''}
                      </span>
                    </Typography.Paragraph>
                  )
                })}
              </div>
            )}
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
